// import { HttpAdapter } from "../../../config/http/http.adapter";
import { HttpAdapter } from '../../../config/http/http.adapter';
import { CashflowInterfaceResponse } from '../../../infraestructure/interfaces/cashflow-trace.interface';
import { CashflowTraceMapper } from '../../../infraestructure/mappers/cashflow-trace.mapper';
import { CashflowChart } from '../../entities/general/CashflowChart.entity';
import { handleError } from '../../handle-error/handleError';
import moment from 'moment';

// Fecha actual en el formato deseado
const currentDate = moment().format('YYYY-MM-DD');

// Fecha restando 12 meses
const originDate = moment().subtract(12, 'months').format('YYYY-MM-DD');

interface Props {
  clientId: string;
  dateFrom: string | Date;
  dateTo: string | Date;
  bankId?: string;
}

export const CashflowTraceUseCases = async (
  fetcher: HttpAdapter,
  props: Props
): //   fetcher: HttpAdapter
Promise<CashflowChart> => {
  try {
    const {
      clientId,
      dateFrom = originDate,
      dateTo = currentDate,
      bankId,
    } = props;

    const requestData: Record<string, string> = {
      clientId: `${clientId}`,
      dateFrom: `${dateFrom}`,
      dateTo: `${dateTo}`,
    };

    if (bankId) {
      requestData.bankId = `${bankId}`;
    }

    const response = await fetcher.post<CashflowInterfaceResponse>(
      '/data-ms/cashflow-trace',
      requestData
    );

    return CashflowTraceMapper.fromResponseToEntity(response);
  } catch (error: any) {
    const processedError = handleError(error);
    console.error('Error procesado:', processedError);
    throw new Error(`${processedError.message} ${processedError.status}`);
  }
};
